// Mock data for Excel Levage website

export const mockStats = {
  yearsExperience: 35,
  projectsDelivered: 500,
  branches: 3
};

export const mockProducts = [
  {
    id: 1,
    name: "overheadCranes",
    description: "overheadCranesDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-revamp-quebec/artifacts/joww2j8m_2-%20Pont%20Roulant%20Excel%20Levage%20Corrig%C3%A9.png",
    capacities: ["3t", "10t", "40t", "Sur mesure"]
  },
  {
    id: 2,
    name: "palansTreeuils",
    description: "palansTreeuilsDesc", 
    image: "https://customer-assets.emergentagent.com/job_excel-revamp-quebec/artifacts/o3u6zw5q_3-%20Palan%20EXL%20Op%C3%A9rateur%20Sans%20Fond.png",
    capacities: ["Électriques", "Pneumatiques", "Manuels"]
  },
  {
    id: 3,
    name: "systemesManutention",
    description: "systemesManutentionDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-revamp-quebec/artifacts/fw5v6ucm_4-%20Station%20Manutention%20EXCEL%20LEVAGE.png",
    capacities: ["Rails", "Chariots", "Convoyeurs de levage"]
  },
  {
    id: 4,
    name: "paniersSupports",
    description: "paniersSupportsDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-revamp-quebec/artifacts/zios6vx2_5-%20Paniers.png",
    capacities: ["Gaz", "Pièces lourdes", "Spécialisés"]
  },
  {
    id: 5,
    name: "maintenance",
    description: "maintenanceDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-revamp-quebec/artifacts/1s7fmvuv_6-%20Maintenance%20Pont%20Roulant.png",
    capacities: ["Inspection", "Certification CSA/ASME", "Maintenance préventive"]
  }
];

export const mockSectors = [
  {
    id: 1,
    name: "manufacturing",
    description: "manufacturingDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/csu0evsr_Excel%20Levage%20-%20Pont%20Roulant%20Correct.jpg",
    applications: ["Acier", "Métal", "Transformation"]
  },
  {
    id: 2,
    name: "agrifood",
    description: "agrifoodDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/zfavwbaz_Excel%20Levage%20-%20Pont%20Roulant%20Jaune%20R%C3%A9aliste%203.png",
    applications: ["Production alimentaire", "Conditionnement", "Hygiène"]
  },
  {
    id: 3,
    name: "energy",
    description: "energyDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/m58oj39q_Excel%20Levage%20-%20Table%20%C3%89l%C3%A9vatrice%20Jaune%20en%20Usine%20Corrig%C3%A9.jpg",
    applications: ["Hydro", "Gaz", "Électricité"]
  },
  {
    id: 4,
    name: "transport",
    description: "transportDesc", 
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/csu0evsr_Excel%20Levage%20-%20Pont%20Roulant%20Correct.jpg",
    applications: ["Entreposage", "Logistique", "Distribution"]
  },
  {
    id: 5,
    name: "construction",
    description: "constructionDesc",
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/zfavwbaz_Excel%20Levage%20-%20Pont%20Roulant%20Jaune%20R%C3%A9aliste%203.png",
    applications: ["Bâtiment", "Infrastructure", "Préfabrication"]
  }
];

export const mockCaseStudies = [
  {
    id: 1,
    title: "caseStudy1Title",
    description: "caseStudy1Desc",
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/csu0evsr_Excel%20Levage%20-%20Pont%20Roulant%20Correct.jpg",
    sector: "manufacturing",
    results: ["+20% productivité", "-30% arrêts imprévus"]
  },
  {
    id: 2,
    title: "caseStudy2Title", 
    description: "caseStudy2Desc",
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/m58oj39q_Excel%20Levage%20-%20Table%20%C3%89l%C3%A9vatrice%20Jaune%20en%20Usine%20Corrig%C3%A9.jpg",
    sector: "energy",
    results: ["Sécurité accrue", "Conformité stricte"]
  },
  {
    id: 3,
    title: "caseStudy3Title",
    description: "caseStudy3Desc", 
    image: "https://customer-assets.emergentagent.com/job_excel-levage/artifacts/zfavwbaz_Excel%20Levage%20-%20Pont%20Roulant%20Jaune%20R%C3%A9aliste%203.png",
    sector: "manufacturing",
    results: ["Ergonomie améliorée", "Réduction des risques"]
  }
];

export const mockResources = [
  {
    id: 1,
    title: "guide1",
    type: "PDF",
    downloadUrl: "#",
    description: "Guide complet pour choisir le bon pont roulant selon vos besoins"
  },
  {
    id: 2,
    title: "guide2",
    type: "PDF", 
    downloadUrl: "#",
    description: "Normes et conformité CSA/ASME pour équipements de levage"
  },
  {
    id: 3,
    title: "guide3",
    type: "PDF",
    downloadUrl: "#", 
    description: "Checklist maintenance préventive pour optimiser vos équipements"
  }
];

export const mockFAQ = [
  {
    id: 1,
    question: "faq1",
    answer: "Oui, nous concevons et fabriquons des solutions sur mesure adaptées à vos besoins spécifiques et contraintes d'installation."
  },
  {
    id: 2,
    question: "faq2", 
    answer: "Absolument. Nous offrons des services complets d'inspection et de certification conformes aux normes CSA et ASME."
  },
  {
    id: 3,
    question: "faq3",
    answer: "Nous installons des équipements de différentes capacités maximales selon les besoins spécifiques de votre projet industriel."
  }
];

// API functions for real backend integration
export const submitSimpleContact = async (formData, language = "fr") => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact/simple`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...formData,
      language: language
    })
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
};

export const submitDetailedContact = async (formData, language = "fr") => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact/detailed`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...formData,
      language: language
    })
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
};

// Legacy mock function for compatibility (deprecated)
export const mockFormSubmission = async (formData) => {
  console.warn("mockFormSubmission is deprecated, use submitSimpleContact or submitDetailedContact");
  return await submitSimpleContact(formData);
};